var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderPackingDetail',{attrs:{"label":"Susulan Promo","type":"free_reimbursement","index-path":_vm.indexPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }